export default __webpack_public_path__ + "static/media/333.ac1b4bae.jpg";